// Advertisements list — Session C migration to the FwTable pattern.
// Same request shape as the AgTable page it replaces; columns from
// agModule.json; permission gates unchanged.
import ModuleListPage from "elements/Table/ModuleListPage";

export default function List() {
  return (
    <ModuleListPage
      module="advertisement"
      title="Advertisements"
      api="admin/advertisement"
      url="advertisement"
      columnsKey="advertisement"
      quickKey="title"
      quickPlaceholder="Filter by title…"
      perms={["adr", "adc", "adu", "add"]}
    />
  );
}
